
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useReactToPrint } from "react-to-print";

const Labels = () => {
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false); 
  const componentRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get("http://localhost:8000/excel/print-new");
        setData(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  const handlePrint = useReactToPrint({
    contentRef: componentRef,
    removeAfterPrint: false,
    onAfterPrint: () => {
      setShowModal(true);
    },
  });

  const confirmPrinted = async () => {
    try {
      const ids = data.map((row) => row.id);
      await axios.post("http://localhost:8000/excel/mark-printed", { ids });

      const res = await axios.get("http://localhost:8000/excel/print-new");
      setData(res.data);

      setShowModal(false); 
    } catch (err) {
      console.error(err);
    }
  };

  const cancelPrinted = () => {
    setShowModal(false); 
  };

  return (
    <div>
      <button
        onClick={handlePrint}
        style={{ margin: "10px", padding: "5px 10px" }}
      >
        Print Labels
      </button>

      <div ref={componentRef}>
        <h2>Client Cartons</h2>
        {data.map((row, index) => (
          <div
            key={`${row.id}-${index}`}
            className="label-box"
            style={{
              border: "1px solid #000",
              padding: "10px",
              margin: "10px 0",
              pageBreakAfter: "always",
            }}
          >
            <strong>{row.cartonLabel}</strong> — {row.hampers} hampers
            <div>
              <span className="to">To: </span>
              {row.to.name}, {row.to.address}, {row.to.city}, {row.to.state} -{" "}
              {row.to.pinCode}
            </div>
            {row.from && (
              <div>
                <span className="to">From: </span>
                {row.from.clientName}, {row.from.clientAddress}
              </div>
            )}
          </div>
        ))}
      </div>

      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              textAlign: "center",
              width: "300px",
            }}
          >
            <p>Did the labels print successfully?</p>
            <button
              onClick={confirmPrinted}
              style={{ margin: "5px", padding: "5px 10px" }}
            >
              Yes
            </button>
            <button
              onClick={cancelPrinted}
              style={{ margin: "5px", padding: "5px 10px" }}
            >
              No
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Labels;
